import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { FormService } from '../../services/form.service';
import { DescriptorFormControl } from '../../descriptor/descriptor-form-control';

@Component({
  selector: 'vedrax-search-autocomplete',
  templateUrl: './vedrax-search-autocomplete.component.html',
  styleUrls: ['./vedrax-search-autocomplete.component.scss']
})
export class VedraxSearchAutocompleteComponent implements OnInit {

  @Input() searchForm: FormGroup = new FormGroup({});

  @Input() filters: DescriptorFormControl[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  getControl(descriptor: DescriptorFormControl): FormControl {
    return this.searchForm.get(descriptor.controlName) as FormControl || new FormControl();
  }

}
